module.exports = __webpack_public_path__ + "static/media/bt_left.f7b3e346.svg";